<div class="flex h-full min-h-0 flex-col gap-4">
  <div class="relative mb-4">
    <div class="custom-form custom-form-readonly">
      <app-talking-point-ai
        [analyticsBadgeLoading]="analyticsStatusBadgeLoading()"
        [analyticsKeywordJump]="jumpToNextKeywordFinding"
        [analyticsKeywordJumpTargets]="keywordTableRowIds()"
        [analyticsKeywordJumpTargetsReady]="keywordTableRowIdsReady()"
        [creatorId]="executionAnalytics()?.creatorId"
        [form]="deliverableForm()"
        [creators]="[]"
        [isCustomMode]="true"
        [isExpanded]="true"
        [isViewMode]="true"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
        [showStatusBadge]="executionAnalytics()?.status !== EMatchingType.planned"
      />
    </div>
  </div>

  @if (manualDeliverableStatusConfig().analyticsVisible) {
    <div class="flex flex-col gap-3">
      <div class="flex items-center justify-between gap-3">
        <h3 class="text-sm font-bold">
          {{ 'pages.campaignDetails.ctaAnalytics.details.detected' | translate }}
          {{ 'pages.campaignDetails.ctaAnalytics.deliverable.' + deliverableType + '.title' | translate | lowercase }}
        </h3>

        <app-segmented-control
          class="shrink-0"
          [loading]="sourceFilterLoading()"
          [options]="sourceFilterOptions()"
          [(value)]="sourceFilter"
        />
      </div>

      <app-line-graph
        class="p-3 bg-shikenso-gray-base-24 rounded-2xl"
        [dotGraphData]="dotGraphData()"
        [viewerGraphData]="viewerGraphData()!"
        (pointSelected)="onDataPointClick($event)"
      />
    </div>

    <app-analytics-details-table
      matSort
      [dataSource]="dataSource"
      [dataCount]="dataCount()"
      [displayedColumns]="displayedColumns"
      [sort]="sort()"
      [selectedRowId]="selectedDataId()"
    >
      <ng-container matColumnDef="timestamp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'pages.campaignDetails.ctaAnalytics.details.talkingPointAi.time' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.timestamp | date: displayTimeFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="videoTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'pages.campaignDetails.ctaAnalytics.details.talkingPointAi.videoTime' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.videoTimeLabel }}</td>
      </ng-container>
      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-20 min-w-20 max-w-20">
          {{ 'pages.campaignDetails.ctaAnalytics.details.talkingPointAi.source' | translate }}
        </th>
        <td mat-cell *matCellDef="let element" [class.chat-source-cell]="element.source === ETalkingPointAiSource.chat">
          {{ 'pages.campaignDetails.ctaAnalytics.details.talkingPointAi.sourceType.' + element.source | translate }}
        </td>
      </ng-container>
      <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'pages.campaignDetails.ctaAnalytics.details.talkingPointAi.message' | translate }}
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="max-w-md text-sm"
          matTooltipPosition="above"
          [attr.tabindex]="element.reason ? 0 : null"
          [matTooltip]="element.reason"
          [matTooltipDisabled]="!element.reason"
        >
          <div class="flex items-center gap-1.5">
            @if (element.sentiment) {
              <app-icon
                class="shrink-0"
                matTooltipPosition="above"
                [src]="getSentimentIcon(element.sentiment)"
                [size]="24"
                [color]="getSentimentIconColor(element.sentiment)"
                [alt]="element.sentiment"
                [matTooltip]="
                  'pages.campaignDetails.ctaAnalytics.details.talkingPointAi.sentimentType.' + element.sentiment
                    | translate
                "
              />
            }
            <span [innerHTML]="highlightKeywords(element.message)"></span>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="flex items-center justify-end gap-1">
            <button
              mat-icon-button
              class="mat-secondary-gray-border-button-color"
              (click)="onRowClick($event, element)"
            >
              <app-icon src="/icons/arrow-up-right.svg" alt="View" [size]="12" />
            </button>
            @if (manualFindingStatusStore) {
              @if (hasRowPendingDeletions(element)) {
                @if (isVisualizerActing(element.id)) {
                  <app-dots-spinner />
                } @else {
                  <button
                    mat-icon-button
                    class="mat-secondary-gray-border-button-color"
                    (click)="onRevertRow(element); $event.stopPropagation()"
                  >
                    <app-icon src="/icons/redo.svg" alt="Revert" [size]="16" />
                  </button>
                }
              } @else if (canDelete()) {
                @if (isFindingInFlight(element.id)) {
                  <app-dots-spinner />
                } @else {
                  <button
                    mat-icon-button
                    class="mat-secondary-gray-border-button-color"
                    (click)="onDeleteSingleRowFinding(element); $event.stopPropagation()"
                  >
                    <app-icon src="/icons/trash.svg" alt="Delete" [size]="16" />
                  </button>
                }
              }
            }
          </div>
        </td>
      </ng-container>
    </app-analytics-details-table>

    @if (shouldRenderEmbeddedPlayer()) {
      <div class="w-full mt-4">
        <app-embedded-video-player
          [videoUrl]="streamUrl()"
          [platform]="platform()!"
          [autoPlay]="false"
          [seekToTime]="seekTime()"
        />
      </div>
    }
  }
</div>
